var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-form__list-group"},[_c('span',{staticClass:"product-form__button product-form__button--wishlist",on:{"click":_vm.toggleWishlist}},[_c('svg',{class:_vm.classes},[_c('use',{attrs:{"xlink:href":"#heart"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }